// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2TGku","content":"layout-module--content--3nIku","body":"layout-module--body--w11mk","banner":"layout-module--banner--2PX9C"};